<template>
  <div>
    <h3 style="text-align: center;">AUTORIZACIÓN EXPRESA PARA EL TRATAMIENTO DE DATOS PERSONALES</h3>
    <p>Autorizo de manera expresa a La Fundación de Apoyo a la Educación y Fomento Empresarial para recolectar,
almacenar, usar, circular, suprimir, procesar, compilar, intercambiar, actualizar y disponer de mis datos personales
que reposan en la base de datos de clientes, así como para transferir dichos datos de manera total o parcial a sus
filiales o vinculadas, así como a sus aliados comerciales estratégicos con fines administrativos, comerciales y de
mercadeo, para el envío de información sobre los diferentes programas y servicios, invitaciones a eventos,
encuestas de calidad de servicio, realizar estudios o investigaciones de mercado, comercialización de servicios y
productos a través de los diferentes canales de información y reportes a centrales de información financiera, los
cuales serán sometidos a los fines establecidos anteriormente conforme a la ley 1581 de 2012 y demás normas
aplicables.</p>
  </div>
</template>

<script>
export default {
  name: 'aporte_titulo_donacion',
  data () {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>